import { create } from 'zustand'

import type { BusinessCreate } from 'src/features/business/shared/schemas/business'

interface FormData extends BusinessCreate {
  desiredLocationType?: 'exact' | 'general' | null
}

interface BusinessCreateState {
  formData: FormData
  setFormData: (formData: FormData) => void
  getFormData: () => FormData
  reset: () => void
}

export const useBusinessCreateStore = create<BusinessCreateState>((set, get) => ({
  formData: {},
  setFormData: (formData) => set({ formData }),
  getFormData: () => get().formData,
  reset: () =>
    set({
      formData: {},
    }),
}))
